/**
 * @generated SignedSource<<8117903a3409541ee4b1838278e443f4>>
 * @relayHash a9b86500fc626329b4a2923105d72712
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/568.0.0-2026-07-14T15:45:41.645Z/GetHelpZendeskContactSupportSearchRefetchQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GetHelpZendeskContactSupportSearchRefetchQuery$variables = {
  contactSupportSearchQuery?: string | null;
  hasContactSupportSearchQuery: boolean;
  isSeller?: boolean | null;
  sellerId?: string | null;
};
export type GetHelpZendeskContactSupportSearchRefetchQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskContactSupportSearch_viewer">;
  };
};
export type GetHelpZendeskContactSupportSearchRefetchQuery = {
  response: GetHelpZendeskContactSupportSearchRefetchQuery$data;
  variables: GetHelpZendeskContactSupportSearchRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contactSupportSearchQuery"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hasContactSupportSearchQuery"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isSeller"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sellerId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GetHelpZendeskContactSupportSearchRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "GetHelpZendeskContactSupportSearch_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "GetHelpZendeskContactSupportSearchRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "isSeller",
                "variableName": "isSeller"
              },
              {
                "kind": "Variable",
                "name": "sellerId",
                "variableName": "sellerId"
              }
            ],
            "concreteType": "Contact1stdibsZendeskArticles",
            "kind": "LinkedField",
            "name": "zendeskArticles",
            "plural": false,
            "selections": [
              {
                "condition": "hasContactSupportSearchQuery",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "supportArticlesSearch",
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "query",
                        "variableName": "contactSupportSearchQuery"
                      }
                    ],
                    "concreteType": "ZendeskArticle",
                    "kind": "LinkedField",
                    "name": "articles",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "serviceId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      (v1/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ]
              }
            ],
            "storageKey": null
          },
          (v1/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/568.0.0-2026-07-14T15:45:41.645Z/GetHelpZendeskContactSupportSearchRefetchQuery",
    "metadata": {},
    "name": "GetHelpZendeskContactSupportSearchRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "efeb20f878e114f553451ec0249d490a";

export default node;
